import LegalLayout, { Section } from "../components/landing/LegalLayout";

export default function Termos() {
  return (
    <LegalLayout title="Termos de Uso" updated="Última atualização: julho de 2026" testid="page-termos">
      <Section n="01" title="Aceitação dos termos">
        <p>
          Ao criar uma conta ou usar o DUELO, você declara que leu, entendeu e
          concorda com estes Termos de Uso, com a Política de Privacidade e com
          as regras oficiais de cada jogo disponível na plataforma.
        </p>
      </Section>
      <Section n="02" title="Elegibilidade">
        <p>
          O DUELO é destinado exclusivamente a maiores de 18 anos. Podemos
          solicitar verificação de identidade e idade a qualquer momento. O modo
          competitivo com créditos só é ativado em regiões onde o modelo esteja
          devidamente autorizado.
        </p>
      </Section>
      <Section n="03" title="Créditos">
        <p>
          Créditos são a moeda virtual da plataforma, com valor definido pelo
          DUELO e exibido antes de cada compra. Cada operação registra o valor
          vigente no momento da transação, e alterações futuras de preço não
          afetam operações já realizadas.
        </p>
      </Section>
      <Section n="04" title="Duelos e resultados">
        <p>
          Em duelos valendo créditos, os valores apostados ficam bloqueados até
          o fim da partida. O resultado é determinado exclusivamente pelo
          servidor — nunca pelo dispositivo do jogador. Em caso de empate, os
          créditos são devolvidos integralmente a cada jogador.
        </p>
      </Section>
      <Section n="05" title="Carteira e uso dos créditos">
        <p>
          Os créditos acumulados podem entrar em novos duelos ou ser trocados
          por produtos na loja do DUELO. Os créditos não são convertidos em
          dinheiro e não há saque: a recompensa é sempre em produtos.
        </p>
      </Section>
      <Section n="06" title="Loja de recompensas">
        <p>
          Créditos podem ser trocados por produtos na loja do DUELO, sujeito à
          disponibilidade de estoque e às regras de cada temporada. Imagens e
          valores de catálogo podem ser atualizados sem aviso prévio.
        </p>
      </Section>
      <Section n="07" title="Antifraude e integridade">
        <p>
          Contas duplicadas, bots, partidas combinadas ou qualquer tentativa de
          manipulação resultam em bloqueio imediato e retenção de saldo para
          análise. Todas as partidas e transações possuem registros imutáveis
          para auditoria.
        </p>
      </Section>
      <Section n="08" title="Contato">
        <p>
          Dúvidas sobre estes termos podem ser enviadas ao nosso suporte 24/7
          dentro do aplicativo ou pelo e-mail duelogames@yahoo.com.
        </p>
      </Section>
    </LegalLayout>
  );
}
